class HeaderNav {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    if (window.matchMedia("(min-width: 768px)").matches) {
      // '.js-pc-header' クラスの要素を選択
      const pcHeader = document.querySelector('.js-pc-header');

      if (pcHeader) {
        // 要素を複製し、'is-fixed' クラスを追加
        const clonedHeader = pcHeader.cloneNode(true);
        clonedHeader.classList.add('is-fixed');

        // 複製された要素の中で 'h1' タグを探し、存在する場合は 'div' に置き換える
        const h1 = clonedHeader.querySelector('h1');
        if (h1) {
          const div = document.createElement('div');
          div.innerHTML = h1.innerHTML;
          div.className = h1.className; // h1のクラスをdivに引き継ぐ
          h1.parentNode.replaceChild(div, h1);
        }

        // 複製された要素を '.js-pc-header' の直後に挿入
        pcHeader.parentNode.insertBefore(clonedHeader, pcHeader.nextSibling);
      } else {
        console.log('.js-pc-header クラスの要素が見つかりません。');
      }

      if ($('body').hasClass('is-top')) {
        ScrollTrigger.create({
          trigger: '.js-header-toggle', // トリガーとなる要素を指定
          start: 'top center', // 画面のどの位置でトリガーするか指定
          onEnter: () => {
            // '.js-header-toggle' がビューポートに入ったときに実行される
            document.querySelectorAll('.js-pc-header.is-fixed').forEach(el => {
              el.classList.add('is-active');
            });
          },
          onLeaveBack: () => {
            // '.js-header-toggle' がビューポートから出たときに実行される
            document.querySelectorAll('.js-pc-header.is-fixed').forEach(el => {
              el.classList.remove('is-active');
            });
          }
        });
      }

    }else{
      const spHeaderToggle = '.js-sp-header-toggle';
      const spHeader = '.js-sp-header-nav';

      $(spHeaderToggle).on('click',function(){
        $(this).toggleClass('is-active');
        $(spHeader).slideToggle();
      })

      $(spHeader).find('.menu-item-has-children .sub-menu').slideUp();
      $(spHeader).find('.menu-item-has-children > a').on('click',function(e){
        e.preventDefault();
        $(this).parent().toggleClass('is-active');
        if($(this).parent().hasClass('is-active')){
          $(this).next().slideDown().css('display','flex');
        }else{
          $(this).next().slideUp();
        }
      })
    }
  }
}